import React from 'react';
import { Box, TextField, MenuItem } from '@mui/material';
import { inputSx, EmptyOption } from './RoadAccidentFormUI';

// Renders the Municipality / Sub-municipality / Suco cascading selects using
// the state produced by useMunicipalityCascade().
const MunicipalityFields = ({ cascade }) => {
  const {
    municipalities,
    subMunicipalities,
    sucos,
    selectedMunicipality,
    selectedSubMunicipality,
    selectedSuco,
    handleMunicipalityChange,
    handleSubMunicipalityChange,
    handleSucoChange,
  } = cascade;

  return (
    <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 2.5 }}>
      <TextField
        label="Municipality"
        select
        size="small"
        fullWidth
        sx={inputSx}
        value={selectedMunicipality}
        onChange={handleMunicipalityChange}
      >
        <EmptyOption text="Select a municipality" />
        {municipalities.map((municipality, index) => (
          <MenuItem key={index} value={municipality.adm1_code}>{municipality.adm1}</MenuItem>
        ))}
      </TextField>

      <TextField
        label="Sub-municipality"
        select
        size="small"
        fullWidth
        sx={inputSx}
        value={selectedSubMunicipality}
        onChange={handleSubMunicipalityChange}
        disabled={!selectedMunicipality}
      >
        <EmptyOption text={selectedMunicipality ? 'Select a sub-municipality' : 'Select a municipality first'} />
        {subMunicipalities.map((submunicipality, index) => (
          <MenuItem key={index} value={submunicipality.adm2_code}>{submunicipality.adm2}</MenuItem>
        ))}
      </TextField>

      <TextField
        label="Suco"
        select
        size="small"
        fullWidth
        sx={inputSx}
        value={selectedSuco}
        onChange={handleSucoChange}
        disabled={!selectedSubMunicipality}
      >
        <EmptyOption text={selectedSubMunicipality ? 'Select a suco' : 'Select a sub-municipality first'} />
        {sucos.map((suco, index) => (
          <MenuItem key={index} value={suco.adm3_code}>{suco.adm3}</MenuItem>
        ))}
      </TextField>
    </Box>
  );
};

export default MunicipalityFields;
